import { Component, OnInit } from '@angular/core';
import { Session } from 'app/shared/services/session/session.service';
import { CONFIG } from 'app/config/config';
import { ActiveUser } from 'app/shared/services/user/active-user.model';

declare var doorbell: any;
declare var window: any;

@Component({
  selector: 'tog-help-and-support',
  templateUrl: './help-and-support.component.html',
  styleUrls: ['./help-and-support.component.scss']
})
export class HelpAndSupportComponent implements OnInit {
  private user: ActiveUser;
  version: string = 'Version ' + CONFIG.VERSION_NUMBER;

  constructor(private _session: Session) { }

  ngOnInit() {
    this._session.user().then((user: ActiveUser) => {
      this.user = user;
      this.initDoorbell(this.user.email);
    })
    .catch((e) => {
      console.log(e);
    });
  }

  initDoorbell(email: string) {
    let currentTime = (new Date().getTime()).toString();

    window.doorbellOptions = {
      hideButton: true,
      email: email,
      appKey: 'T9C24LBmueJY7cmA8FE8eXFyHKbpAlE3MSJuLigLaScToCJAIXdpcoGTlqBJMtvc'
    };
    (function(w, d, t) {
        var hasLoaded = false;
        function l() { if (hasLoaded) { return; } hasLoaded = true; window.doorbellOptions.windowLoaded = true; var g = d.createElement(t);g.setAttribute('id', 'doorbellScript');g.setAttribute('type', 'text/javascript');g.setAttribute('async', 'true');g.setAttribute('src', "https://embed.doorbell.io/button/4437?t="+currentTime);(d.getElementsByTagName('head')[0]||d.getElementsByTagName('body')[0]).appendChild(g); }
        if (w.attachEvent) { w.attachEvent('onload', l); } else if (w.addEventListener) { w.addEventListener('load', l, false); } else { l(); }
        if (d.readyState == 'complete') { l(); }
    }(window, document, 'script'));
  }

  showDoorbellModal() {
    doorbell.show();
  }

  openUserGuide() {
    window.open(CONFIG.SUPPORT_SITE_URL);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/help-and-support/help-and-support.component.ts